import _flatten from "./_flatten.js";
export default function flatten(array, depth) {
  return _flatten(array, depth, false);
}
